import { render, staticRenderFns } from "./PInventoryPooling.vue?vue&type=template&id=175f03f9"
import script from "./PInventoryPooling.vue?vue&type=script&lang=js"
export * from "./PInventoryPooling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports